import { combineReducers } from 'redux';

import { EventReplayConstants as C } from './constants';

export const machines = (state = { items: [], loading: false }, action) => {
  switch (action.type) {
    case C.GET_EVENT_REPLAY_MACHINES_REQUEST:
      return { ...state, loading: true };
    case C.GET_EVENT_REPLAY_MACHINES_SUCCESS:
      return { items: action.payload.items || [], loading: false };
    case C.GET_EVENT_REPLAY_MACHINES_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export const runs = (state = { items: [], loading: false }, action) => {
  switch (action.type) {
    case C.GET_EVENT_REPLAY_RUNS_REQUEST:
      return { ...state, loading: true };
    case C.GET_EVENT_REPLAY_RUNS_SUCCESS:
      return { items: action.payload.items || [], loading: false };
    case C.GET_EVENT_REPLAY_RUNS_FAILURE:
      return { ...state, loading: false, error: action.error };
    case C.DELETE_EVENT_REPLAY_RUN_SUCCESS: {
      const deletedId = action.payload.run_id;
      return {
        ...state,
        items: state.items.map(run => (
          run.id === deletedId ? { ...run, status: action.payload.status } : run
        ))
      };
    }
    default:
      return state;
  }
};

// The run the page is working on: created, previewed, generated, polled.
export const currentRun = (state = { run: null, loading: false }, action) => {
  switch (action.type) {
    case C.CREATE_EVENT_REPLAY_RUN_REQUEST:
      return { run: null, loading: true };
    case C.CREATE_EVENT_REPLAY_RUN_SUCCESS:
      return { run: action.payload, loading: false };
    case C.GET_EVENT_REPLAY_RUN_SUCCESS:
      // A poll that answers after the page left, or after another run was opened,
      // must not put its run back on screen.
      if (action.poll && !(state.run && action.payload && state.run.id === action.payload.id)) return state;
      return { run: action.payload, loading: false };
    case C.GENERATE_EVENT_REPLAY_RUN_SUCCESS:
      return {
        run: state.run ? { ...state.run, ...action.payload, preview: state.run.preview } : action.payload,
        loading: false
      };
    case C.CREATE_EVENT_REPLAY_RUN_FAILURE:
    case C.GET_EVENT_REPLAY_RUN_FAILURE:
      return { ...state, loading: false, error: action.error };
    case C.CLEAR_EVENT_REPLAY_RUN:
      return { run: null, loading: false };
    default:
      return state;
  }
};

export const eventReplayReducer = combineReducers({
  machines,
  runs,
  currentRun
});
